import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const staticAgencyData = {
  menuTitle: MenuTitle.Agency
};

export const Route = createFileRoute('/_private-routes/agency')({
  staticData: staticAgencyData
});
